export default "__VITE_ASSET__9fDSS3Jh__"